import styled from 'styled-components';
import { COLORS } from './variables';

export const LinksDataGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const LayoutFlex = styled.div`
  display: flex;
`;

export const BoxWithMaxWidth = styled.div`
  width: 100%;
`;

export const BoxFlexAllCentered = styled(LayoutFlex)`
  justify-content: center;
  align-items: center;
`;

export const FilterForms = styled(LayoutFlex)`
  flex-direction: column;
  width: 100%;
`;

export const CardRow = styled(LayoutFlex)`
  justify-content: space-between;
  align-items: center;
`;

export const CardRowSpaceAround = styled(LayoutFlex)`
  justify-content: space-around;
  align-items: center;
`;

export const CardLabel = styled.span`
  font-weight: bold;
  color: ${COLORS.primary};
`;

type CardImgType = {
  height?: number;
};

export const CardImgSvg = styled.div`
  border-radius: 50%;
  ${(props: CardImgType) => props?.height && `height: ${props.height}px;`};
`;

export const CardImg = styled(CardImgSvg)`
  box-shadow: inset 0 -3em 3.5em rgba(0, 0, 0, 0.1), 0 0 1em rgba(0, 0, 0, 0.3);
`;

export const CardSvgAction = styled(CardImgSvg)`
  box-shadow: 0 0 0 rgba(255, 255, 255, 0.6), 4px 2px 10px rgba(0, 0, 0, 0.2);
`;

export const FormImg = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -80%);
  box-shadow: inset 0 -3em 3em rgba(0, 0, 0, 0.1), 0 0 0 2px rgb(255, 255, 255), 0 0 0.7em rgba(0, 0, 0, 0.3);
`;
